class NavbarController {
    constructor($state, $stateParams, authService, helpCentreService, DropdownManager, $timeout) {
        'ngInject';
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.authService = authService;
        this.helpCentreService = helpCentreService;
        this.name = 'navbar';
        this.dropdownManager = DropdownManager;
        this.$timeout = $timeout;
    }

    logout() {
        //TODO Move to an abstract state inside auth routes
        this.authService.logout().then(() => {
                this.$state.go('auth.login', {
                    locale: this.$stateParams.locale
                });
        });
    }

}

export default NavbarController;



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js